module.exports = __webpack_public_path__ + "media/images/switch off-602488c71348080adadac81f62b1bf8c.svg";